import { getEnvFromDomainName, /* Environment */ } from './utils';
import { getGraphqlEnv } from './getGraphqlEnv';
import { getCmxEnv } from './getCmxEnv';
export * from './utils';

/**
 * The environment that the application is found to be running in. Note
 * that this environment value may not necessarily be considered a valid
 * environment (dev, qa, pprd, prod).
 * 
 * To temporarily simulate the site running on other environments, modify
 * this value. The other endpoint environments will automatically adjust
 * to attempt to match the application environment as closely as possible.
 */
export const APP_ENV = getEnvFromDomainName( window.location.hostname ); // Environment.QA

export const GRAPHQL_SERVER_ENV = getGraphqlEnv( APP_ENV );
export const CMX_ENV = getCmxEnv( APP_ENV );
